/* import __COLOCATED_TEMPLATE__ from './seller-posting-form.hbs'; */
import { computed } from '@ember/object';
import { readOnly } from '@ember/object/computed';
import { inject as service } from '@ember/service';
import Component from '@ember/component';
import { htmlEntitiesDecode } from '../../utils/misc';
import { htmlSafe } from '@ember/template';

const CLASS_NAME = 'seller-posting-form';

/** @module */
const SellerPostingFormComponent = Component.extend({
  /** @inheritDoc */
  tagName: '',

  get className() {
    return CLASS_NAME;
  },

  /** @type {DS.Model} */
  data: null,

  session: service(),

  /** @type {boolean} */
  disabled: false,

  /** @type {boolean} */
  showMore: false,

  /** @type {Ember.ComputedProperty} */
  isSelect: readOnly('data.select'),

  /** @type {Ember.ComputedProperty} */
  buyerName: readOnly('data.buyer.fullName'),

  /** @type {Ember.ComputedProperty} */
  buyerUrl: computed('data.buyer.slug', function() {
    return `/${this.get('data.buyer.slug')}`;
  }),

  /** @type {Ember.ComputedProperty} */
  companyLogo: computed('data.buyer.company.image.transforms.profile128', 'data.brand.image.transforms.profile128', function() {
    const { brand, buyer } = this.data;
    return brand?.image.transforms.profile128 ?? buyer.company.image.transforms.profile128;
  }),

  /** @type {Ember.ComputedProperty} */
  companyUrl: computed('data.buyer.company.slug', function() {
    return `/company/${this.get('data.buyer.company.slug')}`;
  }),

  /** @type {Ember.ComputedProperty} */
  companyName: computed('data.buyer.company.name', 'data.brand.displayedName', function() {
    const { brand, buyer } = this.data;
    return htmlSafe(brand?.displayedName ?? buyer.company.name);
  }),

  /** @type {Ember.ComputedProperty} */
  description: readOnly('data.descriptionLinkified'),

  /** @type {Ember.ComputedProperty} */
  examples: readOnly('data.examplesLinkified'),

  /** @type {Ember.ComputedProperty} */
  title: computed('data.titleWithUrgent', function() {
    return htmlEntitiesDecode(this.get('data.titleWithUrgent'));
  }),

  /** @inheritDoc */
  actions: {
    /**
     * @param {Event} e
     */
    handleSubmit(e) {
      e.preventDefault();
      this.get('onsubmit')();
    },

    /**
     *
     */
    toggleShowMore() {
      this.toggleProperty('showMore');
    },
  },
});

export default SellerPostingFormComponent;
